import React from "react";
import Skeleton from "@mui/material/Skeleton";

/**
 * Placeholder shown in the Private Wealth grid while product-details are
 * loading for the first time. Sized to match PrivateWealthCard (30px radius,
 * minHeight 309) so real cards don't cause a layout shift on swap-in.
 */
const PrivateWealthCardSkeleton = () => (
  <Skeleton
    variant="rounded"
    sx={{ borderRadius: "30px", height: "100%", minHeight: 309 }}
  />
);

export default PrivateWealthCardSkeleton;
